// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-components-Empty-empty__empty--2c58m{height:100%;flex:1 1 100%;color:#d8dadc;align-items:center;justify-content:center;display:flex;flex-direction:column;text-align:center;padding:20px}.src-routes-App-components-Empty-empty__title--37Vo9{font-size:18px;font-weight:500;margin-bottom:8px}.src-routes-App-components-Empty-empty__message--2i2UP{font-size:14px;margin-bottom:12px}\n", ""]);
// Exports
exports.locals = {
	"empty": "src-routes-App-components-Empty-empty__empty--2c58m",
	"title": "src-routes-App-components-Empty-empty__title--37Vo9",
	"message": "src-routes-App-components-Empty-empty__message--2i2UP"
};
module.exports = exports;
